export const STATE_PROP = 'machineDetails';

export const INITIAL_MACHINE_INFO = {
  id: '',
  alias: '',
  materialNumber: '',
  serialNumber: '',
  thumbnail: '',
  lastConnectedAt: null,
  health: null,
  status: '',
  location: {
    name: '',
    longitude: '',
    latitude: '',
    northLatitude: '',
    eastLongitude: '',
    southLatitude: '',
    westLongitude: ''
  },
  facility: null,
  object: null,
  firstActivationDate: null,
  batteryLevel: null,
  softwareVersion: null
};

export const INITIAL_MACHINE_SUGGESTIONS = {
  facility: [],
  object: []
};

export const BUTTON_MODE = {
  VIEW: 'VIEW',
  EDIT: 'EDIT'
};

export const BATTERY_ENERGY_PERCENT = {
  P_100: '/assets/images/battery/battery-100.svg',
  P_80: '/assets/images/battery/battery-80.svg',
  P_50: '/assets/images/battery/battery-50.svg',
  P_20: '/assets/images/battery/battery-20.svg',
  P_00: '/assets/images/battery/battery-00.svg'
};

export const SOFTWARE_VERSION_CONNECT_REMOTE_MAJOR = 2;
